import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=61462a94&scoped=true"
import script from "./Lab.vue?vue&type=script&lang=js"
export * from "./Lab.vue?vue&type=script&lang=js"
import style0 from "./Lab.vue?vue&type=style&index=0&id=61462a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61462a94",
  null
  
)

export default component.exports